import styled, { css } from 'styled-components';
import DetectableOverflow from 'react-detectable-overflow';

export const Container = styled.div`
  position: relative;
  & + & {
    margin-top: 12px;
  }
`;

interface ILine {
  pointer?: boolean;
}

export const Line = styled.div<ILine>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: default;

  & + & {
    margin-top: 12px;
  }

  ${({ pointer }) =>
    pointer &&
    css`
      cursor: pointer;
    `}
`;

export const TextLeft = styled.div`
  color: #696f8c;
  font-size: 14px;
  font-weight: 400;
  white-space: nowrap;
  margin-right: 16px;
  flex: 1;
  align-self: flex-start;
`;

interface ILineText {
  limitOfLines?: number;
}

export const TextRight = styled(DetectableOverflow)<ILineText>`
  color: #474d66;
  font-size: 14px;
  font-weight: 400;
  text-align: end;
  padding: 0;

  ${({ limitOfLines }) =>
    !!limitOfLines &&
    css`
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: ${limitOfLines}; /* number of lines to show */
      line-clamp: ${limitOfLines};
      -webkit-box-orient: vertical;
    `};
`;

export const TextRightEmpty = styled.div`
  color: #c1c4d6;
  font-size: 14px;
  font-weight: 400;
  text-align: end;
  font-style: italic;
  padding-right: 1px;
`;

export const IconLeft = styled.div`
  height: 20px;
  margin-right: 8px;
`;

export const IconRight = styled.div`
  height: 20px;
  margin-left: 9px;
  cursor: pointer;
`;

export const ToolTipDiv = styled.div`
  display: flex;
  max-width: 320px;
  flex-wrap: wrap;
`;

export const Block = styled.div`
  width: calc(100%);
  position: absolute;
  top: 0;
  left: 0;
  padding: 12px 16px 16px 16px;
  border-radius: 4px;
  box-shadow: 0px 12px 28px rgba(33, 39, 73, 0.2);
  border: 1px solid #edeff4;
  background: #fff;
  z-index: 10;
`;

export const Avatar = styled.img`
  width: 24px;
  height: 24px;
  border-radius: 12px;
  margin-right: 8px;
`;

export const DataLink = styled.a`
  color: #1371fe;
  font-size: 14px;
  font-weight: 500;
  text-align: end;
`;

export const Separator = styled.div`
  height: 12px;
`;

export const ToolTipDivPinned = styled.div`
  display: flex;
  max-width: 234px;
  text-align: center;
  font-weight: 500;
  font-size: 14px;
`;
